import { Component, input } from '@angular/core';
import { AuditLogsComponent } from '../../../../parts/audit-logs/audit-logs.component';
import { AuditEntityType } from '../../../../core/enums/base.enums';
import { UserModel } from '../../../../core/models/data/user.model';

@Component({
  selector: 'ms-user-logs',
  imports: [AuditLogsComponent],
  templateUrl: './user-profile-logs.component.html'
})
export class UserProfileLogsComponent {
  public user = input<UserModel | undefined>(undefined);

  public AuditEntityType = AuditEntityType;
}
